import { render, staticRenderFns } from "./lchemicals.vue?vue&type=template&id=133062ac&"
import script from "./lchemicals.vue?vue&type=script&lang=js&"
export * from "./lchemicals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports